import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import FlameIcon from '../../../images/thermostat-control/thermostat-control-flame.svg';
export const Flame = memo(function Flame(props) {
    const { flame, width, height, style } = props;
    return (_jsx(FlameIcon, { style: {
            color: flame ? '#c4443b' : '#777777',
            opacity: flame ? undefined : 0.3,
            ...style,
        }, width: width ?? 24, height: height ?? 24 }));
});
